import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { connect } from "react-redux";
import { compose } from "redux";
import { Button, Icon, Tag, Tooltip } from "@blueprintjs/core";
import withEditorProps from "../withEditorProps";
import specialCutsiteFilterOptions from "../constants/specialCutsiteFilterOptions";
import React, { useState } from "react";
import "./style.css";
import { popoverOverflowModifiers, TgSelect } from "@teselagen/ui";
import { map, flatMap, includes, pickBy, isEmpty, noop } from "lodash-es";
import { omit } from "lodash-es";
import { showDialog } from "../GlobalDialogUtils";
import {
  addCutsiteGroupClickHandler,
  CutsiteTag,
  getCutsiteWithNumCuts,
  getUserGroupLabel
} from "./AdditionalCutsiteInfoDialog";
import { withRestrictionEnzymes } from "./withRestrictionEnzymes";
import {
  aliasedEnzymesByName,
  cutSequenceByRestrictionEnzyme,
  defaultEnzymesByName
} from "@teselagen/sequence-utils";
const NoResults = withRestrictionEnzymes((props) => {
  const {
    inputSequenceToTestAgainst,
    cutsitesByName,
    cutsitesByNameActive,
    closeDropDown,
    allRestrictionEnzymes,
    queryString = "",
    onHiddenEnzymeAdd,
    manageEnzymesLink
  } = props;
  const enzymesByNameThatMatch = pickBy(allRestrictionEnzymes, function(v, k) {
    if (cutsitesByName[k]) {
      return false;
    }
    return includes(k.toLowerCase(), queryString.toLowerCase());
  });
  if (!isEmpty(enzymesByNameThatMatch)) {
    return /* @__PURE__ */ jsxs("div", { children: [
      "No Active Results.. These inactive enzymes match:",
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("div", { style: { display: "flex" }, children: flatMap(enzymesByNameThatMatch, (e, i) => {
        if (i > 3) return [];
        return /* @__PURE__ */ jsx(
          CutsiteTag,
          {
            onWrapperClick: closeDropDown,
            allRestrictionEnzymes,
            forceOpenCutsiteInfo: true,
            name: e.name,
            cutsitesByName,
            cutsitesByNameActive: cutsitesByName
          },
          i
        );
      }) })
    ] });
  }
  const hiddenEnzymesByNameThatMatch = pickBy(
    aliasedEnzymesByName,
    function(v, k) {
      if (cutsitesByName[k]) {
        return false;
      }
      return includes(k.toLowerCase(), queryString.toLowerCase());
    }
  );
  if (!isEmpty(hiddenEnzymesByNameThatMatch)) {
    return /* @__PURE__ */ jsxs("div", { children: [
      onHiddenEnzymeAdd ? `These Hidden enzymes match, ${map(hiddenEnzymesByNameThatMatch).length > 1 ? `click one` : "click it"} to add it to your enzyme library` : `These Hidden enzymes match, add them via the Manage Enzymes link`,
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("div", { style: { display: "flex" }, children: flatMap(hiddenEnzymesByNameThatMatch, (e, i) => {
        const res = cutSequenceByRestrictionEnzyme(
          inputSequenceToTestAgainst,
          true,
          e
        );
        if (i > 3) return [];
        return /* @__PURE__ */ jsx(
          CutsiteTag,
          {
            onWrapperClick: onHiddenEnzymeAdd ? () => {
              onHiddenEnzymeAdd(e, props);
            } : closeDropDown,
            allRestrictionEnzymes,
            forceOpenCutsiteInfo: !onHiddenEnzymeAdd,
            name: e.name,
            cutsitesByName: {
              ...cutsitesByName,
              [e.name.toLowerCase()]: res
            },
            cutsitesByNameActive
          },
          i
        );
      }) })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "noResultsTextPlusButton", children: [
    "No results... Add enzymes to your list via the ",
    manageEnzymesLink,
    " link",
    " "
  ] });
});
export function CutsiteFilter(props) {
  const {
    onChangeHook,
    style = {},
    filteredRestrictionEnzymes,
    isEnzymeFilterAndUpdate,
    filteredRestrictionEnzymesUpdate: _filteredRestrictionEnzymesUpdate,
    allCutsites: { cutsitesByName },
    allCutsites,
    filteredCutsites,
    onHiddenEnzymeAdd,
    closeDropDown = noop,
    manageEnzymesToLeft,
    enzymeManageOverride,
    enzymeGroupsOverride,
    editorName,
    additionalEnzymes,
    isEnzymeFilterAnd,
    sequenceData
  } = props;
  const showAndOr = filteredCutsites.cutsiteIntersectionCount > 0 && filteredRestrictionEnzymes.length > 1;
  const [queryTracker, setQueryTracker] = useState("");
  const renderOptions = ({ label, value: value2, canBeHidden }, { filteredRestrictionEnzymes: filteredRestrictionEnzymes2, filteredRestrictionEnzymesUpdate: filteredRestrictionEnzymesUpdate2 }) => /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
      },
      children: [
        label,
        " ",
        canBeHidden && /* @__PURE__ */ jsx(
          Icon,
          {
            onClick: (e) => {
              e.stopPropagation();
              filteredRestrictionEnzymesUpdate2(
                flatMap(filteredRestrictionEnzymes2, (e2) => {
                  if (e2.value === value2) return [];
                  return e2;
                }).concat({
                  label,
                  className: "veHiddenEnzyme",
                  value: value2,
                  // hiddenEnzyme: true,
                  isHidden: true,
                  canBeHidden
                })
              );
            },
            htmlTitle: "Hide this enzyme",
            className: "veHideEnzymeBtn",
            style: { paddingTop: 5 },
            iconSize: 14,
            icon: "eye-off"
          }
        )
      ]
    }
  );
  const filteredRestrictionEnzymesUpdate = (enzymes) => {
    _filteredRestrictionEnzymesUpdate(enzymes);
    if (sequenceData?.id) {
      try {
        window.localStorage.setItem(
          `tgInitialCutsiteFilter-${sequenceData.id}`,
          JSON.stringify(
            enzymes.map((e) => omit(e, "canBeHidden", "nameArray", "label"))
          )
        );
      } catch (err) {
        console.warn(`err 872g4e setting enzymes for sequence:`, err);
      }
    }
  };
  const userEnzymeGroups = enzymeGroupsOverride || window.getExistingEnzymeGroups();
  const options = [
    ...map(specialCutsiteFilterOptions, (opt) => opt),
    ...map(userEnzymeGroups, (nameArray, name) => {
      return {
        label: getUserGroupLabel({ nameArray, name }),
        value: "__userCreatedGroup" + name,
        nameArray
      };
    }),
    ...Object.keys(cutsitesByName).sort().map(function(key) {
      const numCuts = (cutsitesByName[key] || []).length;
      const label = getCutsiteWithNumCuts({
        numCuts,
        name: numCuts ? cutsitesByName[key][0].name : key
      });
      return {
        canBeHidden: true,
        label,
        value: key
      };
    })
  ].map((n) => addClickableLabel(n, { closeDropDown }));
  const value = filteredRestrictionEnzymes.map((filteredOpt) => {
    let toRet;
    if (filteredOpt.cutsThisManyTimes || filteredOpt.isSpecialGroup) {
      toRet = filteredOpt;
    } else if (filteredOpt.value.includes("__userCreatedGroup")) {
      toRet = filteredOpt;
    } else {
      const numCuts = (cutsitesByName[filteredOpt.value] || []).length;
      const label = getCutsiteWithNumCuts({
        numCuts,
        name: numCuts ? cutsitesByName[filteredOpt.value][0].name : defaultEnzymesByName[filteredOpt.value]?.name || filteredOpt.value
      });
      toRet = {
        ...filteredOpt,
        label
      };
    }
    return addClickableLabel(toRet, { closeDropDown });
  });
  const numEnzymesInAnd = filteredCutsites.cutsiteIntersectionCount;
  const numEnzymesInOr = filteredCutsites.cutsiteTotalCount;
  const numGroups = filteredRestrictionEnzymes.length;
  const onManageClick = () => {
    enzymeManageOverride ? enzymeManageOverride(props) : showDialog({
      dialogType: "EnzymesDialog"
      // inputSequenceToTestAgainst: sequenceData ? sequenceData.sequence : ""
    });
    closeDropDown();
  };
  const manageEnzymesLink = /* @__PURE__ */ jsx("a", { onClick: onManageClick, style: { width: "fit-content", fontSize: 11 }, children: "Manage Enzymes" });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    manageEnzymesToLeft && /* @__PURE__ */ jsx(
      Button,
      {
        minimal: true,
        "data-tip": "Manage Enzymes",
        onClick: onManageClick,
        icon: "cog"
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          ...style
        },
        children: [
          /* @__PURE__ */ jsx(
            TgSelect,
            {
              additionalRightEl: showAndOr ? /* @__PURE__ */ jsx(
                Tooltip,
                {
                  modifiers: popoverOverflowModifiers,
                  content: isEnzymeFilterAnd ? `AND -- Viewing ${numEnzymesInAnd} enzymes that are shared by ${numGroups === 2 ? "both groups" : `all ${numGroups} groups`}` : `OR -- Viewing ${numEnzymesInOr} enzymes that are in any of the ${numGroups} groups`,
                  children: /* @__PURE__ */ jsxs(
                    Tag,
                    {
                      minimal: true,
                      interactive: true,
                      style: { display: "flex", marginTop: 5 },
                      onClick: (e) => {
                        e.stopPropagation();
                        isEnzymeFilterAndUpdate(!isEnzymeFilterAnd);
                      },
                      children: [
                        /* @__PURE__ */ jsx(
                          "span",
                          {
                            style: {
                              color: isEnzymeFilterAnd ? "#ce5bce" : "darkgray"
                            },
                            children: "AND"
                          }
                        ),
                        "/",
                        /* @__PURE__ */ jsx(
                          "span",
                          {
                            style: {
                              color: !isEnzymeFilterAnd ? "#ce5bce" : "darkgray"
                            },
                            children: "OR"
                          }
                        )
                      ]
                    }
                  )
                }
              ) : false,
              multi: true,
              allowCreate: true,
              wrapperStyle: { zIndex: 11 },
              noResultsText: /* @__PURE__ */ jsx(
                NoResults,
                {
                  inputSequenceToTestAgainst: sequenceData.sequence,
                  manageEnzymesLink,
                  closeDropDown,
                  onHiddenEnzymeAdd,
                  queryString: queryTracker,
                  additionalEnzymes,
                  enzymeGroupsOverride,
                  cutsitesByNameActive: filteredCutsites.cutsitesByName,
                  cutsitesByName: allCutsites.cutsitesByName,
                  editorName
                }
              ),
              onInputChange: (queryTracker2) => {
                setQueryTracker(queryTracker2);
              },
              placeholder: "Filter cut sites...",
              options,
              filteredRestrictionEnzymes,
              filteredRestrictionEnzymesUpdate,
              optionRenderer: renderOptions,
              isSimpleSearch: true,
              onChange: (filteredRestrictionEnzymes2) => {
                onChangeHook && onChangeHook(filteredRestrictionEnzymes2);
                filteredRestrictionEnzymesUpdate(
                  map(filteredRestrictionEnzymes2, (r) => {
                    return omit(r, ["label"]);
                  })
                );
              },
              value
            }
          ),
          !manageEnzymesToLeft && /* @__PURE__ */ jsx("div", { style: { display: "flex", justifyContent: "space-between" }, children: manageEnzymesLink })
        ]
      }
    )
  ] });
}
export default compose(withEditorProps, connect())(CutsiteFilter);
function addClickableLabel(toRet, { closeDropDown }) {
  return {
    ...toRet,
    ...toRet.label ? {
      label: addCutsiteGroupClickHandler({
        closeDropDown,
        cutsiteOrGroupKey: toRet.value,
        el: toRet.label
      })
    } : {}
  };
}
